import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: auto;
  width: 100%;
  color: #fff;
`;
